import React from 'react'

interface LogoMarkProps {
  size?: number
  className?: string
}

/** The canonical ATUUNE mark — the copper/teal ribbon "A" — cropped directly
 * from the brand artwork (frontend/public/atuune-hero-artwork.png). This is
 * the real asset, not a redrawn interpretation: do not replace this <img>
 * with hand-drawn SVG paths. */
export function LogoMark({ size = 40, className = '' }: LogoMarkProps) {
  return (
    <img
      src="/atuune-logo-mark.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={className}
      style={{ width: size, height: size, objectFit: 'contain', display: 'block', flexShrink: 0 }}
    />
  )
}

interface LogoProps extends LogoMarkProps {
  showWordmark?: boolean
  wordmarkClassName?: string
}

/** Full lockup: mark + "ATUUNE" wordmark in dark charcoal. Use LogoMark alone
 * for tight spaces (favicon, mobile collapsed states). */
export function Logo({ size = 36, showWordmark = true, className = '', wordmarkClassName = '' }: LogoProps) {
  return (
    <span className={`atuune-logo ${className}`}>
      <LogoMark size={size} />
      {showWordmark && <span className={`atuune-wordmark ${wordmarkClassName}`}>ATUUNE<sup className="trademark-mark">™</sup></span>}
    </span>
  )
}
